module.exports = __webpack_public_path__ + "static/media/sample.5afaf797.pdf";